import { HelmetDexteel } from "@dexteel/mesf-core";
import { CostCentersManager } from "./components/CostCentersManager";

export const CostCentersPage = () => {
	return (
		<>
			<HelmetDexteel title="Cost Centers" />
			<CostCentersManager />
		</>
	);
};
